import React from 'react';
import type { ImageProps as RNImageProps } from 'react-native';
import { Image as RNImage } from 'react-native';
import { useImageSizeCalculator } from '../hooks/useImageSizeCalculator';

export const BaseImage = (props: RNImageProps) => {
  const { source, ...rest } = props;
  const modifiedSource = useImageSizeCalculator(source);

  return (
    <RNImage
      source={modifiedSource}
      accessibilityIgnoresInvertColors
      {...rest}
    />
  );
};
